import Vue from 'vue'
import EventBus from '../../event-bus'

const SITE = [
  // { name: 'About', content: 'about' },
  {
    name: 'Portfolio',
    content: 'portfolio-menu',
    menu: 'portfolio-menu',
    redirect: true,
    submenu: [
      { name: 'Overview', content: 'portfolio-overview' },
      { name: 'Nike NBA Connected Jersey', content: 'nike-nba-connected-jersey' },
      { name: 'Nike WeChat Campaigns', content: 'nike-wechat-campaigns' },
      { name: 'Lincoln Virtual Car Configurator', content: 'lincoln-virtual-car-config' },
      { name: 'Galaxy Casino Interactive Way-finding Directory', content: 'galaxy-idd' },
      { name: 'Pacific Place Mall Interactive Way-finding Directory', content: 'pacific-place-idd' },
      { name: 'Ford SpecPods & Autoshows', content: 'ford-autoshows' },
      { name: 'Get Work in London Campaign', content: 'london-work-campaign-ar' },
      { name: 'Hong Kong Digital Community Meetup', content: 'hkwd' },
      { name: 'ASOS Urban Tour Campaign', content: 'asos-urban-tour' },
      { name: 'Philips Obsessed with Sound Campaign', content: 'philips-obsessed-with-sound' },
      { name: 'SNCF Les Petits Services', content: 'sncf-les-petits-services' },
      { name: 'Adidas Schneller Ins Trikot', content: 'adidas-schneller-ins-trikot' },
      { name: 'Cadbury YouTube Dance-off Competition', content: 'cadbury-youtube-dance-off' },
      { name: 'City of Port Phillip Sustainability Makeover', content: 'copp-susmakeover' },
      { name: 'Mount Franklin Well of Positivity', content: 'mount-franklin-wop' },
      { name: 'Triumph You are Wonderful Campaign', content: 'triumph-you-are-wonderful' },
      { name: 'Coke Zero Trust Your Buds Campaign', content: 'coke-zero-trust-your-buds' }
    ]
  },
  {
    name: 'Articles',
    content: 'articles',
    menu: 'articles',
    redirect: true,
    submenu: [
      { name: 'Articles', content: 'articles-list' },
      { name: 'Taking a Didi in Shanghai', content: 'didi-chinas-uber' },
      { name: 'Scanning Markers', content: 'scan-insta-qr-ar' },
      { name: 'Half Marathon Facial Recognition', content: 'half-marathon-face-recognition' },
      { name: 'iPhone fully replaces Wallet in Shanghai', content: 'iphone-replaces-wallet' },
      { name: 'Running Technology Teams', content: 'running-technology-teams' },
      { name: 'China Overview 2018', content: 'china-overview-2018' },
      { name: 'Crypto Trading Intro Guide', content: 'crypto-trading-intro-guide' },
      { name: 'Apple Automation - Wake up to Spotify', content: 'apple-automation-wake-up-to-spotify' },
      { name: 'SmartCity: Helsinki', content: 'smartcity-helsinki' }
    ]
  },
  { name: 'Gallery', content: 'gallery' },
  // { name: 'Projects', content: 'projects' },
  { name: 'Labs', content: 'labs' }
  // { name: 'UI-UX', content: 'uiux' }
]

const SITE_LOOKUP = {}

const navItemGetRootParent = function (n) {
  if (n.parent) {
    return navItemGetRootParent(n.parent)
  } else {
    return n
  }
}

const parseNavItem = function (navItem) {
  if (navItem.redirect) {
    return navItem.submenu.list[0]
  } else {
    return navItem
  }
}

class NavItem {
  constructor (label, content, index, depth, parent, menu, redirect) {
    this.label = label
    this.content = content
    this.menu = menu
    this.index = index
    this.depth = depth
    this.parent = parent
    this.redirect = redirect
    this.path = '/' + encodeURI(label.replace(/ /gi, '-').toLowerCase())
    if (parent) {
      this.path = parent.path + this.path
    }
  }
  dataClone () {
    return {
      label: this.label,
      index: this.index,
      depth: this.depth,
      path: this.path
    }
  }
  getRootParent () {
    return navItemGetRootParent(this)
  }
}

class NavTree {
  constructor (items, depth, parent, menu) {
    this.list = []
    for (let i = 0; i < items.length; i++) {
      let n = this.addNav(items[i].name, items[i].content, depth, parent, menu, items[i].redirect)
      if (items[i].submenu) {
        n.submenu = new NavTree(items[i].submenu, depth + 1, n, items[i].menu)
      }
    }
  }
  addNav (label, content, depth, parent, menu, redirect) {
    let n = new NavItem(label, content, this.list.length, depth, parent, menu, redirect)
    this.list.push(n)
    SITE_LOOKUP[n.path] = n
    return n
  }
}

const SiteStructure = new Vue({
  beforeCreate () {
    let navTree = this.navTree = new NavTree(SITE, 0)
    let vm = this

    // Pop State
    window.onpopstate = function (e) {
      let navItem = navTree.list[0]
      if (e.state) {
        if (SITE_LOOKUP[e.state.path]) {
          navItem = SITE_LOOKUP[e.state.path]
          vm.selectedItem = navItem
        }
      }
      EventBus.navChange(parseNavItem(navItem))
    }

    // Default Selection
    if (SITE_LOOKUP[window.location.pathname]) {
      this.selectedItem = parseNavItem(SITE_LOOKUP[window.location.pathname])
    } else {
      this.selectedItem = parseNavItem(SITE_LOOKUP[this.navTree.list[0].path])
    }

    // Paths
    // let pathnames = ["'/'"]
    // for (let name in SITE_LOOKUP) {
    //   pathnames.push("'" + name + "'")
    // }
    // console.log('[', pathnames.join(','), '],')
  },
  methods: {
    getNavTree () {
      return this.navTree
    },
    getRootSelectedItem () {
      return this.selectedItem.getRootParent()
    },
    getSelectedTree () {
      let t = null
      if (this.selectedItem.parent) {
        t = this.selectedItem.parent.submenu
      }
      return t
    },
    getSelectedItem () {
      return this.selectedItem
    },
    setSelectedItem (navItem) {
      navItem = parseNavItem(navItem)
      if (window.location.pathname === navItem.path) return
      window.history.pushState(navItem.dataClone(), navItem.label, navItem.path)
      if (window.ga) {
        window.ga('send', 'pageview', navItem.path)
      }
      this.selectedItem = navItem
      EventBus.navChange(navItem)
    },
    a (e) {
      if (SITE_LOOKUP[e.target.pathname]) {
        this.setSelectedItem(SITE_LOOKUP[e.target.pathname])
        e.preventDefault()
      }
    },
    goto (l) {
      if (SITE_LOOKUP[l]) {
        this.setSelectedItem(SITE_LOOKUP[l])
      }
    }
  }
})

export default SiteStructure
